import React from "react";
import { mdiCloudUpload } from "@mdi/js";
import Icon from "@mdi/react";
import clsx from "clsx";

export interface FileUploaderProps {
  isDragActive: boolean;
  isGlobalDisabled: boolean;
  loading: boolean;
  isUploading: boolean;
  onDrag: (event: React.DragEvent<HTMLElement>) => void;
  onDrop: (event: React.DragEvent<HTMLElement>) => void;
  onClick: () => void;
  inputRef: React.RefObject<HTMLInputElement>;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  multiple?: boolean;
  maxSizeBytes?: number;
}

export const FileUploader = ({
  isDragActive,
  isGlobalDisabled,
  loading,
  isUploading,
  onDrag,
  onDrop,
  onClick,
  inputRef,
  onChange,
  className,
  multiple = true,
  maxSizeBytes = 25 * 1024 * 1024
}: Readonly<FileUploaderProps>) => {
  const isDisabled = isGlobalDisabled || loading || isUploading;
  const maxSizeMegabytes = Math.round(maxSizeBytes / (1024 * 1024));

  const handleClick = () => {
    if (!isDisabled) onClick();
  };

  return (
    <>
      <input
        type="file"
        ref={inputRef}
        className="hidden"
        accept="image/*,application/pdf,.pdf"
        multiple={multiple}
        onChange={onChange}
        disabled={isDisabled}
      />
      <button
        type="button"
        disabled={isDisabled}
        className={clsx(
          "w-full border-2 border-dashed rounded-lg p-6 text-center cursor-pointer transition-colors touch-manipulation",
          isDragActive
            ? "border-primary-500 bg-primary-50"
            : "border-gray-300 hover:border-primary",
          isDisabled && "opacity-50 cursor-not-allowed",
          className
        )}
        onDragEnter={onDrag}
        onDragOver={onDrag}
        onDragLeave={onDrag}
        onDrop={onDrop}
        onClick={handleClick}>
        <div className="flex flex-col items-center justify-center space-y-2">
          <Icon
            path={mdiCloudUpload}
            size={2}
            className={isDragActive ? "text-primary-500" : "text-gray-400"}
          />
          <div className="text-sm text-gray-600">
            {isDragActive ? (
              "Drop the files here"
            ) : (
              <>
                <span className="font-medium text-primary-600">Click to upload</span> or drag and
                drop
                <br />
                <span className="text-xs">Supports: JPG, PNG, PDF (max {maxSizeMegabytes}MB)</span>
              </>
            )}
          </div>
        </div>
      </button>
    </>
  );
};
